module.exports = __webpack_public_path__ + "img/gptw-latam-v2.64b25f09.jpg";